export default __webpack_public_path__ + "static/media/img-egt-swp@3x.67ed36ff.png";